module.exports = __webpack_public_path__ + "img/dis-jinxingzhong.5e541f94.svg";